import React from "react";
import { SidebarOpenButton } from "./nav/SidebarToggle";

const MobileMenuToggle = () => {
  const handleClick = () => {
    const wrapper = document.querySelector("#main-wrapper");
    if (wrapper) {
      wrapper.classList.toggle("menu-toggle");
    }
  };

  return <SidebarOpenButton onClick={handleClick} />;
};

export default MobileMenuToggle;
